"use client";

import type { GpuHealth, PipelineManifest } from "../lib/types";

export interface PipelineStatusProps {
  health: GpuHealth | null;
  pipelines: PipelineManifest[];
}

export function PipelineStatus({ health, pipelines }: PipelineStatusProps) {
  if (!health) {
    return (
      <div className="text-xs text-muted-foreground">Connecting to GPU…</div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-3 text-xs">
      <span className="text-muted-foreground">device: {health.device}</span>
      {pipelines.map((p) => {
        const m = health.models[p.id];
        const state = !m
          ? "unavailable"
          : m.loading
            ? "loading…"
            : m.loaded
              ? "ready"
              : "idle";
        const dot =
          !m
            ? "bg-red-500"
            : m.loading
              ? "bg-amber-500 animate-pulse"
              : m.loaded
                ? "bg-emerald-500"
                : "bg-zinc-400";
        return (
          <span key={p.id} className="flex items-center gap-1.5">
            <span className={`inline-block h-2 w-2 rounded-full ${dot}`} />
            <span>{p.displayName}: {state}</span>
          </span>
        );
      })}
    </div>
  );
}
